import { Game } from './Game';

// 等待 DOM 加载完成
window.addEventListener('DOMContentLoaded', () => {
  const game = new Game();
  game.init();
});
